module.exports = __webpack_public_path__ + "images/todo-actions-icon-f6a8c597a0f624949dff0877cc401b68.png";